import * as Providers from './base';

export default class Google extends Providers.Base {
	set(data) {
		super.set(this.data.event_parameters, data);
	}

	send(callback) {
		super.send(() => {
			window.gtag('event', this.data.event_name, Object.assign(
				{ event_callback: this._function_with_timeout(callback) },
				this.data.event_parameters
			));
		}, callback);
	}
}
